"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74673],{

/***/ 65794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_OfferingSubscription; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/paywall/analytics.ts
var analytics = __webpack_require__(67857);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/features/paywall/Modal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n\n    .ant-modal-close {\n      top: 20px;\n      right: 20px;\n    }\n\n    .ant-modal-close-x {\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n\n      @media ",
        " {\n        width: 40px;\n        height: 40px;\n        line-height: 40px;\n      }\n    }\n  }\n\n  .ant-modal-header {\n    border-radius: 6px 6px 0 0;\n\n    #header-illustration {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      border-radius: 6px 6px 0 0;\n\n      @media ",
        " {\n        height: 200px;\n      }\n\n      @media ",
        " {\n        height: 300px;\n      }\n    }\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    margin-top: -24px;\n\n    @media ",
        " {\n      margin-top: -36px;\n      margin-bottom: 2px;\n    }\n\n    img#offering-illustration {\n      width: 100%;\n    }\n  }\n\n  .ant-modal-footer {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    padding: 20px;\n    flex-direction: column;\n    gap: 10px;\n\n    @media ",
        " {\n      padding: 40px;\n      flex-direction: row;\n      gap: 20px;\n    }\n\n    button {\n      width: 200px !important;\n      padding: 7px 15px 8px 15px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 140%;\n  color: ",
        ";\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 2px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: #ffffff;\n      background: #ebf8f3;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 20px 8px 20px 8px;\n\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  position: relative;\n\n  img.star-left {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  img.star-right {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n  }\n\n  @media ",
        " {\n    padding: 30px 12px 30px 16px;\n    min-height: 124px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  gap: 4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 135%;\n  margin: 0;\n  padding: 0;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 18px;\n  margin: 0;\n  padding: 0;\n\n  @media ",
        " {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-a8a803f1-0"
})(_templateObject(), device/* default.tablet */.Z.tablet, device/* default.mobile */.Z.mobile, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet, device/* default.tablet */.Z.tablet);
var OfferingContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column",
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-a8a803f1-1"
})(_templateObject1());
var TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a8a803f1-2"
})(_templateObject2());
var TitleText = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-a8a803f1-3"
})(_templateObject3(), color/* default.highempahis */.Z.highempahis, device/* default.tablet */.Z.tablet);
var UnderlinedText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a8a803f1-4"
})(_templateObject4(), color/* default.primary */.Z.primary);
var ButtonOffer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a8a803f1-5"
})(_templateObject6(), color/* default.downgray */.Z.downgray, device/* default.tablet */.Z.tablet, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var ButtonTextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a8a803f1-6"
})(_templateObject7(), color/* default.highempahis */.Z.highempahis);
var ButtonTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-a8a803f1-7"
})(_templateObject8(), device/* default.tablet */.Z.tablet);
var ButtonDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-a8a803f1-8"
})(_templateObject9(), device/* default.tablet */.Z.tablet);


;// CONCATENATED MODULE: ./src/features/paywall/Modal/OfferingSubscription/Button.tsx





var ButtonOffering = function(param) {
    var title = param.title, description = param.description, iconUrl = param.iconUrl, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, onClick = param.onClick;
    var suffixName = isActive ? "active" : "right";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOffer, {
        onClick: onClick,
        isActive: isActive,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: iconUrl,
                className: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDescription, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-chevron-").concat(suffixName, ".svg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: isActive,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-star-left.svg"),
                        className: "star-left"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-star-right.svg"),
                        className: "star-right"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Button = (ButtonOffering);

;// CONCATENATED MODULE: ./src/features/paywall/Modal/OfferingSubscription/index.tsx









function OfferingSubscription(param) {
    var _defaultVisible = param.defaultVisible, defaultVisible = _defaultVisible === void 0 ? false : _defaultVisible, _watchParams = param.watchParams, watchParams = _watchParams === void 0 ? false : _watchParams, onVisibleChange = param.onVisibleChange;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var handleRemoveQuery = function() {
        // Remove offeringProVisible from query
        var restQuery = (0,_object_spread/* default */.Z)({}, query);
        delete restQuery.offeringProVisible;
        router.replace({
            query: restQuery
        }, undefined, {
            shallow: true
        });
    };
    var handleVisibleChange = function(payload) {
        setVisible(payload);
        if (onVisibleChange) {
            onVisibleChange(payload);
        }
    };
    var handleNavigate = function(toUrl) {
        handleVisibleChange(false);
        router.push(toUrl);
    };
    (0,react.useEffect)(function() {
        setVisible(defaultVisible);
    }, [
        defaultVisible
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // Check if query has offeringProVisible
        var hasQueryVisible = (query === null || query === void 0 ? void 0 : query.offeringProVisible) === "true";
        var fromDeepLink = (window === null || window === void 0 ? void 0 : (ref = window.history) === null || ref === void 0 ? void 0 : ref.length) <= 2;
        if (hasQueryVisible && fromDeepLink && watchParams) {
            setVisible(true);
            handleRemoveQuery();
        }
    }, [
        query === null || query === void 0 ? void 0 : query.offeringProVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
        centered: true,
        visible: visible,
        onCancel: function() {
            return handleVisibleChange(false);
        },
        maskClosable: false,
        width: 802,
        transitionName: "",
        maskTransitionName: "",
        destroyOnClose: true,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                title: constants/* OfferingPro.open.title */.oz.open.title,
                description: constants/* OfferingPro.open.description */.oz.open.description,
                iconUrl: constants/* OfferingPro.open.iconUrl */.oz.open.iconUrl,
                onClick: function() {
                    analytics/* default.onClickOpenSecurities */.ZP.onClickOpenSecurities();
                    handleNavigate("/securities/auth");
                },
                isActive: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                title: constants/* OfferingPro.subscribe.title */.oz.subscribe.title,
                description: constants/* OfferingPro.subscribe.description */.oz.subscribe.description,
                iconUrl: constants/* OfferingPro.subscribe.iconUrl */.oz.subscribe.iconUrl,
                onClick: function() {
                    analytics/* default.onClickOpenSubscribe */.ZP.onClickOpenSubscribe();
                    handleNavigate("/shop");
                }
            }), 
        ],
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-illustration.svg"),
            id: "header-illustration"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferingContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        children: constants/* OfferingProText.headline */.pj.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnderlinedText, {
                                children: constants/* OfferingProText.underlined */.pj.underlined
                            }),
                            " ",
                            constants/* OfferingProText.unlimited */.pj.unlimited
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var Modal_OfferingSubscription = (OfferingSubscription);


/***/ }),

/***/ 75850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29658);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var features_stream_containers_RegistrationStatus_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75823);
/* harmony import */ var features_shop_revamp_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31366);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(333);
/* harmony import */ var lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11733);
/* harmony import */ var _Modal_OfferingSubscription__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65794);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11298);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35921);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24386);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67857);















var LockedIcon = "/icon/paywall/locked.svg";
function Paywall(param) {
    var source = param.source, height = param.height, className = param.className, isRenewal = param.isRenewal, _isWidget = param.isWidget, isWidget = _isWidget === void 0 ? false : _isWidget, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,features_stream_containers_RegistrationStatus_store__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), data = ref.data, getRegistrationStatus = ref.getRegistrationStatus;
    var ref1 = (0,_store__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(), page = ref1.page, company = ref1.company, widget = ref1.widget;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalVisible = ref2[0], setModalVisible = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__/* .selectors */ .wl), list = ref3.products.list, isLoading = ref3.cart.isLoading;
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_7__/* .selectors */ .wl), _data = ref4.data, isPro = _data.ispro;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        dispatch(lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__/* .thunks.fetchProducts */ .CJ.fetchProducts());
        getRegistrationStatus();
    }, []);
    var getLatestSubscription = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var ref = page || {}, pageData = ref.data;
        var ref1 = company || {}, companyData = ref1.data;
        var ref2 = widget || {}, widgetData = ref2.data;
        var lastSubscriptionData = (pageData === null || pageData === void 0 ? void 0 : pageData.last_subscription) || (companyData === null || companyData === void 0 ? void 0 : companyData.last_subscription) || (widgetData === null || widgetData === void 0 ? void 0 : widgetData.last_subscription);
        var selectedList = list === null || list === void 0 ? void 0 : list.find(function(item) {
            return Number(item.id) === (lastSubscriptionData === null || lastSubscriptionData === void 0 ? void 0 : lastSubscriptionData.id);
        });
        dispatch(lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__/* .thunks.continueSubscribe */ .CJ.continueSubscribe({
            selected: selectedList
        }));
    }, [
        list
    ]);
    var analyticsPayload = {
        oldStatus: Boolean(isPro),
        source: source,
        companyID: symbol
    };
    var handleSetModal = function(visible) {
        setModalVisible(visible);
    };
    var handleOpenAccess = function() {
        handleSetModal(true);
        _analytics__WEBPACK_IMPORTED_MODULE_13__/* ["default"].onClickOpenAccess */ .ZP.onClickOpenAccess(analyticsPayload);
    };
    var handleExtendAccess = function() {
        _analytics__WEBPACK_IMPORTED_MODULE_13__/* ["default"].onClickExtendSubscribe */ .ZP.onClickExtendSubscribe(analyticsPayload);
        if ((0,features_shop_revamp_utils__WEBPACK_IMPORTED_MODULE_6__/* .checkIsWaitingAccount */ .fX)(data === null || data === void 0 ? void 0 : data.status)) {
            router.push("/shop");
            return;
        }
        getLatestSubscription();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .PaywallWrapper */ .Qo, {
                className: className,
                style: {
                    height: height || "auto"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: LockedIcon,
                        alt: "Paywall"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .TextWrapper */ .OP, {
                        isWidget: isWidget,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .Header */ .h4, {
                                children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .HeaderText */ .z
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .Description */ .dk, {
                                children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .DescriptionText */ .RQ
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .ButtonWrapper */ .W4, {
                        isWidget: isWidget,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .ButtonNew */ .M1, {
                                onClick: handleOpenAccess,
                                children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .ButtonNewText */ .Up
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                condition: isRenewal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .ButtonContinue */ .fr, {
                                    disabled: isLoading,
                                    onClick: handleExtendAccess,
                                    children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .ButtonContinueText */ .cY
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal_OfferingSubscription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                defaultVisible: modalVisible,
                onVisibleChange: handleSetModal
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Paywall);


/***/ }),

/***/ 67857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lb": function() { return /* binding */ SideWidgetAnalytics; },
/* harmony export */   "Os": function() { return /* binding */ CompanyAnalytics; },
/* harmony export */   "oF": function() { return /* binding */ PageAnalytics; },
/* harmony export */   "wB": function() { return /* binding */ CompanyWidgetAnalytics; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);
/* eslint-disable no-shadow */ 

var PAYWALL = "Paywall Action";
var ACTION = {
    openAccess: "Paywall Open Access Selected",
    extendSubscribe: "Paywall Extend Subscribe Selected",
    openSecurities: "Paywall Open Securities Selected",
    openSubscribe: "Paywall Subscribe Selected",
    paymentSelected: "Paywall Payment Method Selected",
    inputVoucher: "Paywall Input Voucher Selected",
    confirmPayment: "Paywall Payment Confirmation  Selected",
    selectPlan: "Paywall Subscribe Plan Selected",
    confirmSubscribe: "Paywall Subscribe Confirmation Selected",
    submitVoucher: "Paywall Submit Voucher Selected",
    successSubscribe: "Paywall Subscribe Success Selected"
};
var SideWidgetAnalytics;
(function(SideWidgetAnalytics) {
    SideWidgetAnalytics["PRICE_ALERT"] = "Price Alert (Side Bar)";
    SideWidgetAnalytics["RUNNING_TRADE"] = "Running Trade (Side Bar)";
    SideWidgetAnalytics["VALUATION"] = "Valuation (Side Bar)";
    SideWidgetAnalytics["SCREENER"] = "Screener (Side Bar)";
    SideWidgetAnalytics["BANDAR_DETECTOR"] = "Bandar Detector (Side Bar)";
})(SideWidgetAnalytics || (SideWidgetAnalytics = {}));
var PageAnalytics;
(function(PageAnalytics) {
    PageAnalytics["ORDERBOOK"] = "Orderbook (Top Bar)";
    PageAnalytics["SCREENER"] = "Screener (Top Bar)";
    PageAnalytics["VALUATION"] = "Valuation (Top Bar)";
    PageAnalytics["CALENDAR"] = "Calendar (Top Bar)";
    PageAnalytics["EARNINGS"] = "Earnings (Top Bar)";
    PageAnalytics["CHARTBIT"] = "Chartbit (Top Bar)";
})(PageAnalytics || (PageAnalytics = {}));
var CompanyAnalytics;
(function(CompanyAnalytics) {
    CompanyAnalytics["ORDERBOOK"] = "Orderbook (Company)";
    CompanyAnalytics["RUNNING_TRADE"] = "Running Trade (Company)";
    CompanyAnalytics["KEYSTATS"] = "Keystats (Company)";
    CompanyAnalytics["ANALYST"] = "Analysis (Company)";
    CompanyAnalytics["FINANCIALS"] = "Financials (Company)";
    CompanyAnalytics["FUNDACHART"] = "Fundachart (Company)";
    CompanyAnalytics["SEASONALITY"] = "Seasonality (Company)";
    CompanyAnalytics["CHARTBIT"] = "Chartbit (Company)";
    CompanyAnalytics["COMPARISON"] = "Comparison (Company)";
    CompanyAnalytics["INSIDER"] = "Insider (Company)";
    CompanyAnalytics["PROFILE"] = "Company Profile (Company)";
    CompanyAnalytics["CORPACTION"] = "Corporate Action (Company)";
})(CompanyAnalytics || (CompanyAnalytics = {}));
var CompanyWidgetAnalytics = {
    Orderbook: "Orderbook (Company)",
    "Running Trade": "Running Trade (Company)",
    "Trade Book": "Trade Book (Company)",
    "Broker Summary": "Broker Summary (Company)"
};
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["bca_va"] = "BCA";
    PaymentMethod["veritrans"] = "Credit Card";
    PaymentMethod["gopay"] = "Gopay";
})(PaymentMethod || (PaymentMethod = {}));
function formatDuration(durationString) {
    var duration = parseInt(durationString, 10);
    if (Number.isNaN(duration)) {
        return durationString;
    }
    if (durationString.includes("MONTH")) {
        return "".concat(duration, " Bulan");
    }
    if (durationString.includes("YEAR")) {
        return "".concat(duration, " Tahun");
    }
    if (durationString.includes("DAY")) {
        return "".concat(duration, " Hari");
    }
    return durationString;
}
var createPaywallEvent = function(action, params) {
    var oldStatus = params.oldStatus, source = params.source, companyID = params.companyID;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
        Action: action,
        "Old Subscriber Pro": oldStatus,
        Source: source,
        "Company ID": companyID
    });
};
var PaywallAnalytics = {
    onClickOpenAccess: function(params) {
        createPaywallEvent(ACTION.openAccess, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params));
    },
    onClickExtendSubscribe: function(params) {
        createPaywallEvent(ACTION.extendSubscribe, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params));
    },
    onClickOpenSecurities: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.openSecurities
        });
    },
    onClickOpenSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.openSubscribe
        });
    },
    onClickPaymentSelected: function(paymentMethod) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.paymentSelected,
            "Metode Pembayaran": PaymentMethod[paymentMethod]
        });
    },
    onClickInputVoucher: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.inputVoucher
        });
    },
    onClickConfirmPayment: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.confirmPayment
        });
    },
    onClickSelectPlan: function(plan) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.selectPlan,
            "Subscription Period": formatDuration(plan)
        });
    },
    onClickConfirmSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.confirmSubscribe
        });
    },
    onClickSubmitVoucher: function(voucher) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.submitVoucher,
            Voucher: voucher
        });
    },
    onClickSuccessSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.successSubscribe
        });
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (PaywallAnalytics);


/***/ }),

/***/ 35921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ CompanyWidgetHeaderTitle; },
/* harmony export */   "M1": function() { return /* binding */ ButtonNew; },
/* harmony export */   "OP": function() { return /* binding */ TextWrapper; },
/* harmony export */   "Qo": function() { return /* binding */ PaywallWrapper; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "XE": function() { return /* binding */ WidgetOrderbookHeader; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "fr": function() { return /* binding */ ButtonContinue; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "iV": function() { return /* binding */ LastPrice; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "j2": function() { return /* binding */ CompanyWidgetWrapper; },
/* harmony export */   "kF": function() { return /* binding */ CompanyWidgetHeader; },
/* harmony export */   "qh": function() { return /* binding */ PaywallPageWrapper; },
/* harmony export */   "wv": function() { return /* binding */ WidgetWrapper; }
/* harmony export */ });
/* unused harmony exports PaywallPage, CustomNotProWrapper, OldNotProContainer, NotProWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var global_NotPro_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92768);
/* harmony import */ var global_NotPro__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89698);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 20px auto auto auto;\n  padding: 80px 0;\n  border-radius: 2px;\n  min-height: 316px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 330px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background-color: ",
        ";\n\n  & > img {\n    width: 42px;\n    height: 42px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin: 20px auto auto -10px;\n      width: calc(100% + 20px);\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px 20px auto 20px;\n  max-width: none;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  height: auto;\n  max-width: 843px;\n\n  @media ",
        " {\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0px;\n  padding: 50px 0;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 80%;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 700;\n  text-align: center;\n  width: 80%;\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #858585;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      flex-direction: column !important;\n      gap: 8px !important;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n\n  @media ",
        " {\n    flex-direction: row;\n    gap: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 154px;\n  height: 28px;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: initial;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  border-color: ",
        ";\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  margin-bottom: 20px;\n  position: relative;\n\n  ",
        " {\n    font-size: 13px;\n    line-height: 18px;\n    width: 80%;\n  }\n\n  ",
        " {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  border-bottom: solid 1px ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 135%;\n  font-weight: 700;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #121212;\n  border-radius: 3px;\n  padding: 0px 6px;\n\n  & > p {\n    color: ",
        ";\n    font-size: 12px;\n    margin: 0;\n    padding: 2px 0;\n    line-height: initial;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  line-height: initial;\n\n  & > p {\n    color: ",
        ";\n    font-size: 12px;\n    margin: 0;\n  }\n\n  & > span {\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      border-radius: 2px;\n      height: auto;\n      max-width: 1000px;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  max-width: none;\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0px;\n  padding: 50px 0;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var NotProWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-1"
})(_templateObject1());
var PaywallWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light);
var PaywallPageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(NotProWrapper).withConfig({
    componentId: "sc-21ee1089-3"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileL */ .Z.mobileL, function(param) {
    var isFlexible = param.isFlexible;
    return isFlexible && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3());
});
var PaywallPage = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(PaywallWrapper).withConfig({
    componentId: "sc-21ee1089-4"
})(_templateObject5());
var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-5"
})(_templateObject7(), function(param) {
    var isWidget = param.isWidget;
    return isWidget && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject6());
});
var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-21ee1089-6"
})(_templateObject8(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileL */ .Z.mobileL);
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-21ee1089-7"
})(_templateObject9());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-8"
})(_templateObject11(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileL */ .Z.mobileL, function(param) {
    var isWidget = param.isWidget;
    return isWidget && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject10());
});
var ButtonNew = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    type: "primary"
}).withConfig({
    componentId: "sc-21ee1089-9"
})(_templateObject12());
var ButtonContinue = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(ButtonNew).attrs({
    type: "default"
}).withConfig({
    componentId: "sc-21ee1089-10"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-11"
})(_templateObject14(), function(param) {
    var height = param.height;
    return height;
});
var CompanyWidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-12"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro, Header, Description);
var CompanyWidgetHeader = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-13"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var CompanyWidgetHeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    type: "h5"
}).withConfig({
    componentId: "sc-21ee1089-14"
})(_templateObject17());
var WidgetOrderbookHeader = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-15"
})(_templateObject18());
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-16"
})(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light);
var LastPrice = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-21ee1089-17"
})(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dimgray */ .Z.dimgray);
var CustomNotProWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(global_NotPro_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotProWrapper */ .CW).withConfig({
    componentId: "sc-21ee1089-18"
})(_templateObject22(), function(param) {
    var isPro = param.isPro;
    return !isPro && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject21(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
});
var OldNotProContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(global_NotPro__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-21ee1089-19"
})(_templateObject23());



/***/ }),

/***/ 30690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* binding */ OA_REGISTER_STATUS; },
/* harmony export */   "Gj": function() { return /* binding */ SUBSCRIPTION_ALIAS; },
/* harmony export */   "f2": function() { return /* binding */ SUBSCRIPTION_PACKAGE; },
/* harmony export */   "z": function() { return /* binding */ PAYMENT_OPTION; }
/* harmony export */ });
/* unused harmony export PAYMENT_METHOD */
var PAYMENT_METHOD;
(function(PAYMENT_METHOD) {
    PAYMENT_METHOD["PAYMENT_METHOD_GOPAY"] = "PAYMENT_METHOD_GOPAY";
    PAYMENT_METHOD["PAYMENT_METHOD_BCA_VA"] = "PAYMENT_METHOD_BCA_VA";
    PAYMENT_METHOD["PAYMENT_METHOD_CREDIT_CARD"] = "PAYMENT_METHOD_CREDIT_CARD";
    PAYMENT_METHOD["PAYMENT_METHOD_BANK_TRANSFER"] = "PAYMENT_METHOD_BANK_TRANSFER";
    PAYMENT_METHOD["PAYMENT_METHOD_CIMB_CLICKS"] = "PAYMENT_METHOD_CIMB_CLICKS";
    PAYMENT_METHOD["PAYMENT_METHOD_BRI_EPAY"] = "PAYMENT_METHOD_BRI_EPAY";
    PAYMENT_METHOD["PAYMENT_METHOD_MIDTRANS"] = "PAYMENT_METHOD_MIDTRANS";
})(PAYMENT_METHOD || (PAYMENT_METHOD = {}));
var PAYMENT_OPTION = [
    {
        id: 0,
        name: "Gopay",
        code: PAYMENT_METHOD.PAYMENT_METHOD_GOPAY,
        description: "gopay",
        icon: "gopay_round"
    },
    {
        id: 1,
        name: "BCA Virtual Account",
        code: PAYMENT_METHOD.PAYMENT_METHOD_BCA_VA,
        description: "bca_va",
        icon: "bca_va"
    },
    {
        id: 2,
        name: "Credit Card / Transfer ATM / Mandiri Clickpay",
        code: PAYMENT_METHOD.PAYMENT_METHOD_MIDTRANS,
        description: "veritrans",
        icon: "veritrans"
    }, 
];
var SUBSCRIPTION_ALIAS = {
    SUBSCRIPTION_ONE_YEAR: "1 Tahun Berlangganan",
    SUBSCRIPTION_SIX_MONTHS: "6 Bulan Berlangganan",
    SUBSCRIPTION_ONE_MONTH: "1 Bulan Berlangganan",
    SUBSCRIPTION_ONE_DAY: "1 Hari Berlangganan"
};
var SUBSCRIPTION_PACKAGE = {
    SUBSCRIPTION_ONE_YEAR: "1 Tahun Stockbit Pro",
    SUBSCRIPTION_SIX_MONTHS: "6 Bulan Stockbit Pro",
    SUBSCRIPTION_ONE_MONTH: "1 Bulan Stockbit Pro",
    SUBSCRIPTION_ONE_DAY: "1 Hari Stockbit Pro"
};
var OA_REGISTER_STATUS;
(function(OA_REGISTER_STATUS) {
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["HAS_NOT_STARTED"] = 0] = "HAS_NOT_STARTED";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["INCOMPLETE"] = 1] = "INCOMPLETE";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["CS_PROGRESS"] = 2] = "CS_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["KSEI_PROGRESS"] = 3] = "KSEI_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["RDN_PROGRESS"] = 4] = "RDN_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["SUBMIT_REGISTRATION"] = 5] = "SUBMIT_REGISTRATION";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["DOCUMENT_VERIFICATION"] = 88] = "DOCUMENT_VERIFICATION";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["REJECTED"] = 99] = "REJECTED";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["OTHERS"] = -1] = "OTHERS";
})(OA_REGISTER_STATUS || (OA_REGISTER_STATUS = {}));


/***/ }),

/***/ 31366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XP": function() { return /* binding */ translatePackageOption; },
/* harmony export */   "fX": function() { return /* binding */ checkIsWaitingAccount; },
/* harmony export */   "gs": function() { return /* binding */ createMonthlyStatements; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30690);



var createMonthlyStatements = function(orders) {
    var dict = {};
    orders.forEach(function(order) {
        var month = moment__WEBPACK_IMPORTED_MODULE_0___default()(order.date).format("MMMM YYYY");
        if (Array.isArray(dict[month])) {
            dict[month].push(order);
        } else {
            dict[month] = [
                order
            ];
        }
    });
    return dict;
};
var translatePackageOption = function() {
    var packageItem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", dateOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(packageItem === null || packageItem === void 0 ? void 0 : packageItem.split(" "), 2), tmp = ref[0], packageDuration = tmp === void 0 ? "" : tmp, tmp1 = ref[1], packageType = tmp1 === void 0 ? "" : tmp1;
    switch(packageType.toLowerCase()){
        case "month":
            {
                if (Number(packageDuration) >= 12) {
                    return "1 Tahun ".concat(dateOnly && "Stockbit Pro");
                }
                return "".concat(packageDuration, " Bulan ").concat(dateOnly ? "Stockbit Pro" : "");
            }
        case "day":
            {
                return "".concat(packageDuration, " Hari ").concat(dateOnly ? "Stockbit Pro" : "");
            }
        default:
            {
                return "".concat(packageDuration, " Tahun ").concat(dateOnly ? "Stockbit Pro" : "");
            }
    }
};
var checkIsWaitingAccount = function(status) {
    var waitingStatuses = [
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.CS_PROGRESS */ .Es.CS_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.KSEI_PROGRESS */ .Es.KSEI_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.RDN_PROGRESS */ .Es.RDN_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.SUBMIT_REGISTRATION */ .Es.SUBMIT_REGISTRATION,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.DOCUMENT_VERIFICATION */ .Es.DOCUMENT_VERIFICATION, 
    ];
    return waitingStatuses.includes(status);
};


/***/ }),

/***/ 75823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82670);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65906);





var registrationStatusStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return {
        data: {
            status: 0
        },
        isLoading: false,
        error: null,
        getRegistrationStatus: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response, _data, data, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        set({
                            isLoading: true,
                            error: null
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_securities__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getOAStatus */ .Z.getOAStatus();
                    case 4:
                        response = _ctx.sent;
                        if (response === null || response === void 0 ? void 0 : response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        set({
                            isLoading: false
                        });
                        throw new Error("Attempt to fetch oa status failed");
                    case 8:
                        _data = response.data, data = _data.data, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        set({
                            isLoading: false,
                            error: _$error
                        });
                        return _ctx.abrupt("return");
                    case 12:
                        set({
                            data: data,
                            isLoading: false,
                            error: null
                        });
                        _ctx.next = 22;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ctx.t0, Error)) {
                            _ctx.next = 21;
                            break;
                        }
                        ;
                        set({
                            isLoading: false,
                            error: _ctx.t0.message
                        });
                        return _ctx.abrupt("return");
                    case 21:
                        ;
                    case 22:
                        _ctx.prev = 22;
                        set({
                            isLoading: false
                        });
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15,
                    22,
                    25
                ]
            ]);
        }))
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (registrationStatusStore);


/***/ }),

/***/ 89698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_NotPro; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/global/NotPro/constants.ts
var subscribeMessage = "This feature is exclusive for PRO users";
var subscribeButton = "Subscribe";


// EXTERNAL MODULE: ./src/global/NotPro/styled.ts
var styled = __webpack_require__(92768);
;// CONCATENATED MODULE: ./src/global/NotPro/index.tsx






function NotPro(param) {
    var width = param.width, height = param.height, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WidgetAction */.uu, {
        className: className,
        style: {
            height: height || "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: subscribeMessage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LinkSubscribeWrapper */.oo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/shop",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonSubscribe */.an, {
                            type: "primary",
                            width: width,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    className: "icon-setting_subscribe",
                                    color: color/* default.light */.Z.light
                                }),
                                subscribeButton
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var global_NotPro = (NotPro);


/***/ }),

/***/ 92768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ NotProWrapper; },
/* harmony export */   "an": function() { return /* binding */ ButtonSubscribe; },
/* harmony export */   "oo": function() { return /* binding */ LinkSubscribeWrapper; },
/* harmony export */   "uu": function() { return /* binding */ WidgetAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin-top: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  margin: 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 330px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var WidgetAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d3e5ef6-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light);
var LinkSubscribeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d3e5ef6-1"
})(_templateObject1());
var ButtonSubscribe = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5d3e5ef6-2"
})(_templateObject2(), function(props) {
    return props.width || "80%";
});
var NotProWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5d3e5ef6-3"
})(_templateObject3());



/***/ }),

/***/ 11733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_shop; },
  "wl": function() { return /* binding */ selectors; },
  "CJ": function() { return /* binding */ thunks; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/shop.ts


// init request config
var request = (0,requestExodus/* default */.Z)();
// constants
var SHOP_URL = "".concat(api/* API_EXODUS_URL */.q7, "/pro-sub");
// api wrappers
var getProducts = function() {
    return request.get("".concat(SHOP_URL, "/products"));
};
var addItems = function(id, quantity) {
    return request.post("".concat(SHOP_URL, "/cart/item"), {
        id: id,
        quantity: quantity
    });
};
var removeItem = function() {
    return request.delete("".concat(SHOP_URL, "/cart"));
};
var getCart = function() {
    return request.get("".concat(SHOP_URL, "/cart"));
};
var checkout = function(gateway) {
    return request.post("".concat(SHOP_URL, "/cart/checkout"), {
        gateway: gateway
    });
};
var applyCoupon = function(coupon) {
    return request.post("".concat(SHOP_URL, "/coupon"), {
        coupon: coupon
    });
};
var removeCoupon = function() {
    return request.delete("".concat(SHOP_URL, "/coupon"));
};
var applyVoucher = function(voucher) {
    return request.post("".concat(SHOP_URL, "/voucher"), {
        voucher: voucher
    });
};
var removePromo = function(type) {
    return request.delete("".concat(SHOP_URL, "/").concat(type));
};
var getSubscriptions = function() {
    return request.get("".concat(SHOP_URL, "/subscription"));
};
var activateFreeTrial = function() {
    return request.post("".concat(SHOP_URL, "/free-trial/activate"));
};
var getPurchaseHistory = function(params) {
    return request.get("".concat(SHOP_URL, "/order/history"), {
        params: params
    });
};
/* harmony default export */ var shop = ({
    getProducts: getProducts,
    getCart: getCart,
    addItems: addItems,
    checkout: checkout,
    applyCoupon: applyCoupon,
    removeCoupon: removeCoupon,
    applyVoucher: applyVoucher,
    removeItem: removeItem,
    removePromo: removePromo,
    getSubscriptions: getSubscriptions,
    getPurchaseHistory: getPurchaseHistory,
    activateFreeTrial: activateFreeTrial
});

// EXTERNAL MODULE: ./src/features/shop-revamp/utils.ts
var utils = __webpack_require__(31366);
;// CONCATENATED MODULE: ./src/lib/entities/shop.ts









// lib

// types

// constants
var CONTEXT = "@entity/shop";
var actionType = {
    GET_PRODUCTS: "".concat(CONTEXT, "/GET_PRODUCTS"),
    CART_ADD_ITEM: "".concat(CONTEXT, "/CART_ADD_ITEM"),
    CONTINUE_SUBSCRIBE: "".concat(CONTEXT, "/CONTINUE_SUBSCRIBE"),
    CART_ADD_RECENT_ITEM: "".concat(CONTEXT, "/CART_ADD_RECENT_ITEM"),
    CART_REMOVE_ITEM: "".concat(CONTEXT, "/CART_REMOVE_ITEM"),
    CART_FETCH: "".concat(CONTEXT, "/CART_FETCH"),
    PAYMENT_CHECKOUT: "".concat(CONTEXT, "/PAYMENT_CHECKOUT"),
    APPLY_COUPON: "".concat(CONTEXT, "/APPLY_COUPON"),
    APPLY_VOUCHER: "".concat(CONTEXT, "/APPLY_VOUCHER"),
    REMOVE_PROMO: "".concat(CONTEXT, "/REMOVE_PROMO"),
    REMOVE_COUPON: "".concat(CONTEXT, "/REMOVE_COUPON"),
    GET_PURCHASE: "".concat(CONTEXT, "/GET_PURCHASE"),
    ACTIVATE_FREE: "".concat(CONTEXT, "/ACTIVATE_FREE"),
    GET_PURCHASE_HISTORY: "".concat(CONTEXT, "/GET_PURCHASE_HISTORY")
};
var initialState = {
    products: {
        isLoading: false,
        list: [],
        error: null,
        message: null
    },
    cart: {
        isLoading: false,
        error: null,
        products: [],
        promos: null,
        totals: null
    },
    payment: {
        isLoading: false,
        error: null,
        gateway: "bca_va",
        paymentURL: null,
        paymentType: "popup",
        orderId: ""
    },
    purchase: {
        isLoading: true,
        error: null,
        purchases: []
    },
    activateFreeTrial: {
        isLoading: true,
        error: null
    },
    history: {
        isLoading: false,
        orders: {},
        subscription: null
    }
};
// reducers
var reducers = {
    setGateway: function(draft, actions) {
        draft.payment.gateway = actions.payload;
    }
};
// thunks
var thunks = {
    // -- Fetch products
    fetchProducts: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PRODUCTS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getProducts();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data, message = _data.message;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        products: data,
                        message: message
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Add items
    addItems: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_ADD_ITEM, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var selected, rejectWithValue, code, id, quantity, response, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selected = param.selected, rejectWithValue = param1.rejectWithValue;
                        code = selected.code, id = selected.id;
                        quantity = parseInt(code.substring(5, 7), 10);
                        if (quantity) {
                            _ctx.next = 6;
                            break;
                        }
                        rejectWithValue(quantity);
                        throw new Error("Invalid quantity format!");
                    case 6:
                        _ctx.next = 8;
                        return shop.addItems(id, quantity);
                    case 8:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(error);
                    case 12:
                        return _ctx.abrupt("return", {
                            data: [
                                response.data.data
                            ]
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    continueSubscribe: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONTINUE_SUBSCRIBE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var selected, rejectWithValue, code, id, quantity, response, responseCart, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selected = param.selected, rejectWithValue = param1.rejectWithValue;
                        code = selected.code, id = selected.id;
                        quantity = parseInt(code.substring(5, 7), 10);
                        if (quantity) {
                            _ctx.next = 6;
                            break;
                        }
                        rejectWithValue(quantity);
                        throw new Error("Invalid quantity format!");
                    case 6:
                        _ctx.next = 8;
                        return shop.addItems(id, quantity);
                    case 8:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        return shop.getCart();
                    case 11:
                        responseCart = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 15;
                            break;
                        }
                        throw new Error(error);
                    case 15:
                        return _ctx.abrupt("return", {
                            data: [
                                response.data.data
                            ],
                            cart: responseCart.data.data
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Add items
    removeItem: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_REMOVE_ITEM, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.removeItem();
                case 2:
                    response = _ctx.sent;
                    data = response.data;
                    error = data.error;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        message: "success"
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch Cart
    fetchCart: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_FETCH, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getCart();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        products: data.products,
                        promos: data.promos,
                        totals: data.totals
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Checkout
    checkout: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.PAYMENT_CHECKOUT, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(gateway) {
            var response, _data, data, error, apiURL, paymentType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.checkout(gateway);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        if (!(data === null || data === void 0 ? void 0 : data.action)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            paymentType: "popup",
                            snapToken: data.action.snap_token,
                            clientKey: data.action.client_key,
                            orderId: data.action.order_id
                        });
                    case 8:
                        apiURL = new URL(data.url);
                        paymentType = gateway === "veritrans" ? "redirect" : "popup";
                        return _ctx.abrupt("return", {
                            gateway: data.gateway,
                            url: data.url,
                            paymentType: paymentType,
                            snapToken: apiURL.searchParams.get("snap_token"),
                            clientKey: apiURL.searchParams.get("client_key")
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(gateway) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    applyCoupon: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.APPLY_COUPON, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(coupon) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.applyCoupon(coupon);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    applyVoucher: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.APPLY_VOUCHER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(coupon) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.applyVoucher(coupon);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    removePromo: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.REMOVE_PROMO, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.removePromo(type);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Remove Coupon
    removeCoupon: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.REMOVE_COUPON, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.removeCoupon();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch products
    getPurchase: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PURCHASE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getSubscriptions();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data, message = _data.message;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        purchases: data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch products
    activateFreeTrial: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.ACTIVATE_FREE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message, error_type;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.activateFreeTrial();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data;
                    message = data.message, error_type = data.error_type;
                    if (!(error || error_type)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    fetchPurchaseHistory: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PURCHASE_HISTORY, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var params, response, _data, error, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = {
                        last_id: 0,
                        limit: 10
                    };
                    _ctx.next = 3;
                    return shop.getPurchaseHistory(params);
                case 3:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })))
};
var extraReducers = function(builder) {
    return builder// Fetch products
    .addCase(thunks.fetchProducts.pending, function(draft) {
        draft.products.isLoading = true;
    }).addCase(thunks.fetchProducts.fulfilled, function(draft, actions) {
        draft.products.isLoading = false;
        draft.products.list = actions.payload.products;
        draft.products.message = actions.payload.message;
        draft.products.error = null;
    }).addCase(thunks.fetchProducts.rejected, function(draft, actions) {
        draft.products.isLoading = false;
        draft.products.error = actions.error;
    })// -- Add to cart
    .addCase(thunks.addItems.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.addItems.fulfilled, function(draft, actions) {
        draft.cart.error = null;
        draft.cart.isLoading = false;
        draft.cart.products = actions.payload.data;
        router_default().push("/shop/cart");
    }).addCase(thunks.addItems.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// Continue Subscribe
    .addCase(thunks.continueSubscribe.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.continueSubscribe.fulfilled, function(draft, actions) {
        draft.cart.error = null;
        draft.cart.isLoading = false;
        draft.cart.products = actions.payload.cart.products;
        router_default().push("/shop/cart");
    }).addCase(thunks.continueSubscribe.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// -- Fetch cart
    .addCase(thunks.fetchCart.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.fetchCart.fulfilled, function(draft, actions) {
        draft.cart = {
            isLoading: false,
            error: null,
            products: actions.payload.products,
            promos: actions.payload.promos,
            totals: actions.payload.totals,
            applyingVoucher: false
        };
    }).addCase(thunks.fetchCart.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// -- Checkout
    .addCase(thunks.checkout.pending, function(draft) {
        draft.payment.isLoading = true;
    }).addCase(thunks.checkout.fulfilled, function(draft, actions) {
        draft.payment.error = null;
        draft.payment.isLoading = false;
        draft.payment.paymentType = actions.payload.paymentType;
        draft.payment.gateway = actions.payload.gateway;
        draft.payment.paymentURL = actions.payload.url;
        draft.payment.snapToken = actions.payload.snapToken;
        draft.payment.clientKey = actions.payload.clientKey;
    }).addCase(thunks.checkout.rejected, function(draft, actions) {
        draft.payment.isLoading = false;
        draft.payment.error = actions.error;
    }).addCase(thunks.removeItem.fulfilled, function() {
        router_default().push("/shop");
    }).addCase(thunks.applyCoupon.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    }).addCase(thunks.applyVoucher.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    }).addCase(thunks.removePromo.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    })// Fetch Purchases
    .addCase(thunks.getPurchase.pending, function(draft) {
        draft.purchase.isLoading = true;
    }).addCase(thunks.getPurchase.fulfilled, function(draft, actions) {
        draft.purchase.isLoading = false;
        draft.purchase.purchases = actions.payload.purchases;
    }).addCase(thunks.getPurchase.rejected, function(draft, actions) {
        draft.purchase.isLoading = false;
        draft.purchase.error = actions.error;
    })// Fetch Purchases
    .addCase(thunks.activateFreeTrial.pending, function(draft) {
        draft.activateFreeTrial.isLoading = true;
    }).addCase(thunks.activateFreeTrial.fulfilled, function(draft, actions) {
        draft.activateFreeTrial.isLoading = false;
    }).addCase(thunks.activateFreeTrial.rejected, function(draft, actions) {
        draft.activateFreeTrial.isLoading = false;
    })// Fetch Purchase History
    .addCase(thunks.fetchPurchaseHistory.pending, function(draft) {
        draft.history.isLoading = true;
    }).addCase(thunks.fetchPurchaseHistory.fulfilled, function(draft, actions) {
        draft.history.isLoading = false;
        draft.history.orders = (0,utils/* createMonthlyStatements */.gs)(actions.payload.data.orders);
        draft.history.subscription = actions.payload.data.subscription;
    }).addCase(thunks.fetchPurchaseHistory.rejected, function(draft, actions) {
        draft.history.isLoading = false;
    });
};
// selectors
var shopEntitySelector = function(state) {
    return state.entities.shop;
};
var selectProductList = function(state) {
    return state.products.list.map(function(param) {
        var description = param.description, keyword = param.keyword, price = param.price;
        return {
            duration: description,
            price: (numeral_default()(price).value() / 1000).toString(),
            description: keyword,
            features: "Full Features"
        };
    });
};
var selectors = (0,es/* createSelector */.P1)(shopEntitySelector, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.products), {
            availableProducts: selectProductList(state)
        })
    });
});
// slice
var shopSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    initialState: initialState,
    name: "shop",
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_shop = (shopSlice);


/***/ })

}]);